module.exports = __webpack_public_path__ + "img/create-overlay2.02e1a3fc.png";